// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //base_api: 'http://localhost/GWConek',
  //base_api: 'https://gwapi03.onesms.vn',
  //base_api: 'https://gw-bank-api.onesms.vn',
  //  base_api: 'http://localhost:44399',
  base_api: '', //https://localhost:5001
  base_api_thong_ke: 'https://apistatistics.conek.vn',
  google_provider_id:
    '255956828275-f9328ug1j1srmv61lej8fqr5nk51b7km.apps.googleusercontent.com',
  facebook_provider_id: '420804301804120',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
